import { render, staticRenderFns } from "./InfoDectation.vue?vue&type=template&id=23ff0909&scoped=true&"
import script from "./InfoDectation.vue?vue&type=script&lang=js&"
export * from "./InfoDectation.vue?vue&type=script&lang=js&"
import style0 from "./InfoDectation.vue?vue&type=style&index=0&id=23ff0909&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ff0909",
  null
  
)

export default component.exports